var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounLayers145272(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    stroke: "none",
    fill: "#0089d0",
    r: "48%",
    cx: "50%",
    cy: "50%"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(45 45) scale(0.69 0.69) rotate(0) translate(-50 -50)",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M23.1,0.7L1.2,12.1c-0.9,0.5-0.9,1.9,0,2.4l21.9,11.4c0.6,0.3,1.3,0.3,1.9,0l21.9-11.4   c0.9-0.5,0.9-1.9,0-2.4L24.9,0.7C24.3,0.4,23.7,0.4,23.1,0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M46.8,22.7l-4.1-2.1c-0.2-0.1-0.5-0.1-0.8,0l-15.7,8.2c-0.7,0.4-1.5,0.5-2.2,0.5c-0.8,0-1.5-0.2-2.2-0.5   L6.1,20.6c-0.2-0.1-0.5-0.1-0.8,0l-4.1,2.1c-0.9,0.5-0.9,1.9,0,2.4l21.9,11.4c0.6,0.3,1.3,0.3,1.9,0l21.9-11.4   C47.7,24.6,47.7,23.2,46.8,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M46.8,33.5l-4.1-2.1c-0.2-0.1-0.5-0.1-0.8,0l-15.7,8.2c-0.7,0.4-1.5,0.5-2.2,0.5c-0.8,0-1.5-0.2-2.2-0.5   L6.1,31.4c-0.2-0.1-0.5-0.1-0.8,0l-4.1,2.1c-0.9,0.5-0.9,1.9,0,2.4l21.9,11.4c0.6,0.3,1.3,0.3,1.9,0l21.9-11.4   C47.7,35.4,47.7,34,46.8,33.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounLayers145272);
export default __webpack_public_path__ + "static/media/noun_Layers_145272.a511c32c.svg";
export { ForwardRef as ReactComponent };